import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccessibilityModule } from '@fgb/portal-component-library/accessibility';
import { NotificationModule } from '@fgb/portal-component-library/src/lib/club/notification';
import { NavbarDirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { CartItemModule } from '@fgb/portal-component-library/src/lib/loyalty/cart-item';
import { WalletTextWithBadgeComponent } from '@fgb/portal-component-library/src/lib/loyalty/wallet';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { LanguageSelectorModule } from '@fgb/portal-component-library/src/lib/shared/language-selector';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SharedModule } from 'src/app/shared/shared.module';
import { ClubModule } from '../club/club.module';
import { GuardianModule } from '../guardian/guardian.module';
import { UserModule } from '../user/user.module';
import { ArenaCashNavComponent } from './components/arena-cash-nav/arena-cash-nav.component';
import { BannerComponent } from './components/banner/banner.component';
import { FloatingCartButtonComponent } from './components/floating-cart-button/floating-cart-button.component';
import { FooterComponent } from './components/footer/footer.component';
import { GameNavComponent } from './components/game-nav/game-nav.component';
import { LeaderboardV2NavComponent } from './components/leaderboard-v2-nav/leaderboard-v2-nav.component';
import { MobileNavMenuComponent } from './components/mobile-nav-menu/mobile-nav-menu.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { NavigationIndicatorComponent } from './components/navigation-indicator/navigation-indicator.component';
import { TicketNavComponent } from './components/ticket-nav/ticket-nav.component';
import { PopupNotificationComponent } from './components/popup-notification/popup-notification.component';
import { CartButtonComponent } from '@fgb/portal-component-library/src/lib/shared/cart-button';
import { PaymentNavbarComponent } from './components/payment-navbar/payment-navbar.component';
import { MixedLoyaltyNavComponent } from './components/mixed-loyalty-nav/mixed-loyalty-nav.component';
import { FantasyNavV2Component } from './components/fantasy-nav-v2/fantasy-nav-v2.component';

@NgModule({
  declarations: [
    NavBarComponent,
    NavigationIndicatorComponent,
    FooterComponent,
    GameNavComponent,
    MobileNavMenuComponent,
    TicketNavComponent,
    PopupNotificationComponent,
    FloatingCartButtonComponent,
    ArenaCashNavComponent,
    LeaderboardV2NavComponent,
    BannerComponent,
    PaymentNavbarComponent,
    MixedLoyaltyNavComponent,
    FantasyNavV2Component,
  ],
  exports: [
    NavBarComponent,
    NavigationIndicatorComponent,
    FooterComponent,
    GameNavComponent,
    MobileNavMenuComponent,
    TicketNavComponent,
    PopupNotificationComponent,
    FloatingCartButtonComponent,
    ArenaCashNavComponent,
    LeaderboardV2NavComponent,
    BannerComponent,
    PaymentNavbarComponent,
    MixedLoyaltyNavComponent,
    FantasyNavV2Component,
  ],
  imports: [
    RouterModule,
    NgbModule,
    CommonModule,
    FormsModule,
    InlineSVGModule,
    SharedModule,
    UserModule,
    ClubModule,
    GuardianModule,
    LanguageSelectorModule,
    LoyaltyIconModule,
    CartItemModule,
    AccessibilityModule,
    NotificationModule,
    NavbarDirectivesModule,
    FGBSharedModule,
    WalletTextWithBadgeComponent,
    CartButtonComponent,
  ],
})
export class LayoutModule {}
